import { CRow, CCol } from "@coreui/react";
import React, { Children } from "react";

const FormBlock: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <CRow>
      {Children.map(children, (child, idx) => (
        <CCol md={3} sm={6} xs={12} key={idx}>
          {child}
        </CCol>
      ))}
    </CRow>
  );
};

export default FormBlock;
